<template>
  <button data-test="us-arrow-button" class="us-arrow-button">
    <USIcon
      :class="['us-arrow-button__icon', `us-arrow-button__icon--${direction}`]"
      :name="`chevron-${direction}`"
      fill="black"
      color="var(--color--neutral-a5)"
      css-diameter="var(--iconDiameter)"
    />
  </button>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'

import USIcon from '../USIcon/USIcon.vue'

export default defineComponent({
  name: 'USArrowButton',
  components: {
    USIcon
  },
  props: {
    direction: { type: String as PropType<'left' | 'right'>, default: 'left' },
    fill: { type: String, default: '#ffffff' }, // ignored
    color: { type: String, default: '#4f3b80' } // ignored
  }
})
</script>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint';

$buttonDiameter--mobile: 56px;
$buttonDiameter--tablet: 64px;
$buttonDiameter--desktop: 84px;

.us-arrow-button {
  --iconDiameter: 13px;
  align-items: center;
  // backdrop-filter: blur(10px);
  background-color: rgba(white, 0.4);
  border-radius: var(--border-radius--round);
  display: flex;
  height: $buttonDiameter--mobile;
  justify-content: center;
  width: $buttonDiameter--mobile;

  @include breakpoint.min-width(breakpoint.$breakpoint--tablet) {
    height: $buttonDiameter--mobile;
    width: $buttonDiameter--mobile;
  }

  @include breakpoint.min-width(breakpoint.$breakpoint--desktop) {
    height: $buttonDiameter--mobile;
    width: $buttonDiameter--mobile;
  }

  // Temporary, manually compensate for icon not having a 1:1 aspect-ratio
  &__icon {
    &--left {
      transform: translateX(-10%);
    }

    &--right {
      transform: translateX(10%);
    }
  }
}
</style>

<!-- TODO
- Get icon variant with 1:1 aspect-ratio from design
-->
